import React from 'react';

export const Input = ({ className = '', ...props }) => (
  <input
    className={`border rounded px-4 py-2 focus:outline-none focus:ring ${className}`}
    {...props}
  />
);
